import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'
import { MoreHorizontal } from 'lucide-react'
import type { RowAction } from './types'

interface IntuiTableRowActionsProps<T> {
  row: T
  actions: RowAction<T>[]
}

export function IntuiTableRowActions<T>({
  row,
  actions,
}: IntuiTableRowActionsProps<T>) {
  const visibleActions = actions.filter(
    (action) => !action.isVisible || action.isVisible(row)
  )

  if (visibleActions.length === 0) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 p-0"
          onClick={(e) => e.stopPropagation()}
        >
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {visibleActions.map((action) => (
          <DropdownMenuItem
            key={action.label}
            onClick={(e) => {
              e.stopPropagation()
              action.onClick(row)
            }}
            className={cn(
              'cursor-pointer',
              action.isDestructive && 'text-destructive focus:text-destructive'
            )}
          >
            {action.icon && <span className="mr-2">{action.icon}</span>}
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
